import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import config from "../../config";

const productSlice = createSlice({
  name: "product",

  initialState: {
    productData: [],
    isLoading: false,
    isError: false,
  },

  reducers: {
    fetchProductStart: (state) => {
      state.isLoading = true;
      state.isError = false;
    },
    fetchProductSuccess: (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.productData = action.payload;
    },
    fetchProductFailure: (state) => {
      state.isLoading = false;
      state.isError = true;
    },
  },
});

export const {
  fetchProductStart,
  fetchProductSuccess,
  fetchProductFailure,
} = productSlice.actions;

export const fetchProduct = () => async (dispatch) => {
  try {
    dispatch(fetchProductStart());
    const response = await axios.get(`${config.apiUrl}/product-list`);
    dispatch(fetchProductSuccess(response.data.data));
  } catch (error) {
    dispatch(fetchProductFailure());
  }
};

export default productSlice.reducer;
